import React from 'react'
import { checkTextTranslation, checkTranslation, getObject, translate } from '../../utils/useful'
import FormViewer from '../FormViewer'
import SidebarView from '../SidebarView'
import ButtonAnimated from '../buttons/ButtonAnimated'

class AddressInput extends React.Component {
    state = {
        fields: [
            { type: 'SelectInput', key: 'country', information: { label: '{{lang}}Country', address: 'getCountries', filter: {}, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}Country', required: true }, showMain: true },
            { type: 'TextAreaInput', key: 'address', information: { label: '{{lang}}Address', placeholder: '{{lang}}Address', required: true } },
            { type: 'TextAreaInput', key: 'address2', information: { label: '{{lang}}Address 2', placeholder: '{{lang}}e.g. Suite #', required: false } },
            { type: 'TextInput', key: 'city', col: '6', information: { label: '{{lang}}City', placeholder: '{{lang}}City', required: true } },
            {
                type: 'SelectInput', key: 'state', col: '6', information: { label: '{{lang}}state', address: 'getStates', filter: { "country": '{{country}}' }, fields: { title: 'name', value: '_id' }, type: 'api', isSearchable: true, placeholder: '{{lang}}State', required: true },
                dependencies: [{
                    refKey: 'country', targetKey: 'state',
                    conditions: [{
                        root: { id: 'root', action: 'and', conditions: { 1: { id: 1, source: { value: true }, operator: { value: '==' }, target: { value: true } } }, },
                        effect: { show: true, changeHeader: [{ key: 'filter.country', value: '@data.country' }] }
                    }],
                    else: { show: true },
                    init: true,

                }],
                showMain: true
            },

            { type: 'TextInput', key: 'zipCode', col: '6', information: { label: '{{lang}}Zip Code', placeholder: '{{lang}}Zip Code', required: false } },
        ],

        tempData: null

    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.value : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value, this.props.extra)
        }
    }

    componentDidMount() {
        // console.log('this.props.data', this.props?.data)
    }
    focus = () => {
        this.input.focus()
    }
    selectHandler = () => {

    }
    liveChange = (data, init, key, value, extra, full) => {

        let info = this.props.header?.information

        // if(this.props.header?.information?.helperKey){

        // }
        // let helperKey = this.props.header?.information?.helperKey ? ('.' + this.props.header?.information?.helperKey) : ''
        // console.log('Full', data, init, key, value, extra, full)
        if (key && !init) {
            let myFullData = {}
            let initData = this.props.data ? JSON.parse(JSON.stringify(this.props.data)) : null

            if (info.inplaceView) {
                myFullData = (this.state.tempData ?? initData) ?? {}
            } else {
                myFullData = initData ?? {}
            }



            myFullData[key] = value

            if (key == "country" || key == 'state') {
                if (!myFullData.cashed) {
                    myFullData.cashed = {}
                }

                myFullData.cashed[key] = full

            }


            // console.log(myFullData)
            if (!info.inplaceView) {
                this.props.changeValue(this.props.header?.key, myFullData, this.props.extra)
            } else {
                this.setState({ tempData: myFullData })
            }

        }
    }

    getForm = () => {
        return this.form.getForm()
    }

    submit = () => {
        let form = this.form.getForm()
        if (form) {

            // console.log((this.state.tempData ?? this.props.data))
            this.props.changeValue(this.props.header?.key, (this.state.tempData ?? this.props.data), this.props.extra)

            this.sidebarView.close()

        }

    }


    render() {
        let info = this.props.header?.information
        let data
        if (this.props.header?.information?.helperKey) {
            let helperKey = this.props.header?.information?.helperKey ? ('.' + this.props.header?.information?.helperKey) : ''
            data = {
                country: getObject(this.props.fullData, (helperKey + 'country')),
                state: getObject(this.props.fullData, (helperKey + 'state')),
                city: getObject(this.props.fullData, (helperKey + 'city')),
                zipCode: getObject(this.props.fullData, (helperKey + 'zipCode')),
                address: getObject(this.props.fullData, (helperKey + 'address')),
                address2: getObject(this.props.fullData, (helperKey + 'address2')),

            }
        } else {
            data = this.props.data
        }

        // console.log(this.props.data)
        // console.log(this.props.header)



        return (
            <div className="w-100 "  >

                {info.inplaceView ? (
                    <div className='p-2 br-4 mb-2' style={{ border: '1px solid #eee' }}>
                        <p className='input-value font-size-14'>{data?.address} {data?.address2}</p>
                        <p className='input-value font-size-14'>{data?.city} {data?.cashed?.state?.title} {data?.cashed?.country?.title} {data?.zipCode}</p>
                        <div className=' '>
                            {data?.address ? (
                                <button className='text-link' onClick={() => this.sidebarView.open()}>{translate("Edit address")}</button>

                            ) : (
                                <button className='text-link' onClick={() => this.sidebarView.open()}>{translate("Add address")}</button>

                            )}

                        </div>
                    </div>
                ) : (
                    <div className='p-2 br-4 mb-2' style={{ border: '1px solid #eee' }}>
                        <FormViewer ref={el => this.form = el} liveChange={this.liveChange} initData={data} headers={this.state.fields} formClass={this.props.formClass} inputClass={this.props.inputClass} nopadding={true} noMargin={true} marginBottom={0} />
                    </div>
                )}

                <SidebarView hight={"100%"} width={this.props.width} ref={el => this.sidebarView = el} hideOverlay={false} widthCondition={{ xs: "100%", sm: "100%", md: '50%', lg: "33.3%", xl: "25%" }} left={50}>

                    <div className=" pb-3  h-100 scroll-no-scrollbar" style={{ backgroundColor: '#fff', borderRadius: 8, minWidth: 150 }}>
                        <div className='flexcb pb-1 mb-3 px-3 top-0 pt-1' style={{ zIndex: 1, borderBottom: '1px solid #eee', background: '#fff', position: 'sticky' }}>
                            <p className='text-bold font-size-15'>{checkTranslation(info.label)}</p>
                            <div className='flexc'>
                                <ButtonAnimated
                                    iconwidth='24px'
                                    onClick={() => this.submit()}
                                    title={translate('Submit')}
                                    icon='/assets/icons/plus-white.svg'
                                    textColor={'#fff'}
                                    isLoading={this.props.isLoadingView}
                                    bg={this.props.background ?? ' linear-gradient(90deg, #5856D6, #7D7AFF)'}
                                    width={'100%'}
                                />
                            </div>
                        </div>
                        <div className='px-3 w-100'>
                            <FormViewer ref={el => this.form = el} liveChange={this.liveChange} initData={data} headers={this.state.fields} formClass={this.props.formClass} inputClass={this.props.inputClass} nopadding={true} noMargin={true} />
                        </div>
                    </div>
                </SidebarView>
            </div>
        )
    }
}

export default AddressInput;